module.exports = __webpack_public_path__ + "static/img/135.f1ad9a23.gif";